import { useState } from "react";
import type { AppSummary, Transport } from "@compath/renderer";
import type { Principal } from "../../controllers/oidc";
import type { OpenApp } from "../../models/types";
import { metaFor } from "../../models/catalog";
import { RunningApp } from "./RunningApp";

// 확장 앱: per-project extension apps. Apps the account has (bought/enabled in the 앱 마켓 → entitled)
// are runnable here in the context of a project. Picking one opens its window immediately — e.g.
// selecting BeyondCDX launches the SBOM analyzer inline.
export function ProjectExtApps({
  apps, transport, principal, projectName,
}: {
  apps: AppSummary[];
  transport: Transport;
  principal: Principal;
  projectName: string;
}) {
  const [open, setOpen] = useState<OpenApp | null>(null);
  const available = apps.filter((a) => a.entitled);

  if (open) {
    return <RunningApp open={open} transport={transport} principal={principal} onClose={() => setOpen(null)} />;
  }

  return (
    <div>
      <h1 className="ext-title">확장 앱</h1>
      <p className="ext-sub">
        앱 마켓에서 구매·설치한 앱을 이 프로젝트에서 바로 실행합니다{projectName ? ` · ${projectName}` : ""}.
      </p>
      {available.length === 0 ? (
        <div className="ext-empty">
          사용 가능한 확장 앱이 없습니다. 상단 <b>앱</b> 메뉴의 마켓에서 앱을 구매·설치하면 여기에 표시됩니다.
        </div>
      ) : (
        <div className="ext-grid">
          {available.map((a) => {
            const m = metaFor(a.id);
            return (
              <button
                key={a.id}
                className="ext-card"
                onClick={() => setOpen({ appId: a.id, screen: a.home ?? `${a.id}/home`, name: a.name })}
              >
                <span className="ext-ico" style={{ background: m.tint }}>{m.emoji}</span>
                <span className="ext-name">{a.name}</span>
                <span className="ext-desc">{m.summary}</span>
                <span className="ext-open">열기 →</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
